import { find, keyBy } from 'lodash';
import AssessmentStatus from '@/models/AssessmentStatus';
import Status from '@/models/Status';

export const assessmentStatusMixin = {
  props: {
    reviewPendingSubmissions: {
      type: Array,
      default: () => []
    },
    assessmentSubmissionStatus: {
      type: AssessmentStatus
    }
  },

  computed: {
    statues() {
      return keyBy(Status.all(), 'id');
    },

    defaultStatus() {
      return find(this.statues, { name: Status.NOT_SUBMITTED });
    },

    currentStatus() {
      return this.assessmentSubmissionStatus
        ? this.statues[this.assessmentSubmissionStatus.status_id]
        : this.defaultStatus;
    },

    reviewPendingCount() {
      return this.reviewPendingSubmissions.length;
    }
  }
};
